import { createContext } from 'react'

export const ProcedureManagementContext = createContext(null)

export const FormTypeContext = createContext()

export const AlertContext = createContext()

export const QuestionsAndSubQuestionsContext = createContext()
